import { useState, useEffect } from "react";
import { post } from "./utils";
import AppShell from "./AppShell";
import { Spin, GenericDetailView } from "./DocDetailTab";

// Fetches via advance_filter and renders using exact same GenericDetailView as DocDetailTab
function FilterDetailLoader({ session, docId, doctypeId }) {
  const user      = session?.user;
  const activeSub = session?.subproject;
  const [data,    setData]    = useState(null);
  const [loading, setLoading] = useState(true);
  const commentId = new URLSearchParams(window.location.search).get("commentid");

  useEffect(()=>{
    if(!user||!activeSub||!docId) return;
    post("advance_filter", {
      subprojectid: activeSub.SUBPROJECTID,
      userid:       user.USERID,
      doctypeid:    doctypeId,
      documentid:   docId,
    }, user.AUTH_CODE)
    .then(r=>{
      if(r.STATUS==="1"&&Array.isArray(r.DATA)&&r.DATA.length>0)
        setData(r.DATA[0]);
    })
    .catch(()=>{})
    .finally(()=>setLoading(false));
  // eslint-disable-next-line
  },[docId]);

  if(loading) return <Spin/>;
  if(!data)   return(
    <div style={{display:"flex",alignItems:"center",justifyContent:"center",
      height:"100%",color:"#EF4444",fontSize:"13px"}}>
      Content not found
    </div>
  );

  return <GenericDetailView d={data} user={user} activeSub={activeSub} scrollToComment={commentId}/>;
}

export default function FilterDetailTab({ session, onLogout, docId, doctypeId }) {
  return(
    <AppShell session={session} onLogout={onLogout}
      overrideContent={
        <FilterDetailLoader
          session={session}
          docId={docId}
          doctypeId={doctypeId}/>
      }
      hideNav={true}
      hideFilterButtons={true}/>
  );
}